import { ModelConfig } from '@rematch/core';
import { company } from '../../../models/entities/company/company';
import { localSDK as client } from '../../../sdk';

export type PlatformCompaniesState = {
    companies: company[];
    total: number;
    gridFilter: string;
    lastError: string | null;
};

export const platformCompanies: ModelConfig<PlatformCompaniesState> = {
    state: {
        companies: [],
        total: 0,
        gridFilter: '',
        lastError: null
    },
    reducers: {
        setCompanies(state, payload: { companies: company[]; total: number }) {
            return { ...state, companies: payload.companies, total: payload.total, lastError: null };
        },
        setGridFilter(state, gridFilter: string) {
            return { ...state, gridFilter };
        },
        setLastError(state, lastError: string | null) {
            return { ...state, lastError };
        }
    },
    effects: (dispatch: any) => ({
        async fetchCompanies() {
            try {
                const { data, total } = await client.platformCompanies().fetchCompanies([0, 499]);
                dispatch.platformCompanies.setCompanies({ companies: data, total });
            } catch (error: any) {
                dispatch.platformCompanies.setLastError(error?.message || 'Failed to load companies');
                throw error;
            }
        },
        async saveCompany(payload: { id?: string; data: Partial<company> }) {
            try {
                if (payload.id) {
                    await client.platformCompanies().updateCompany(payload.id, payload.data);
                } else {
                    await client.platformCompanies().createCompany(payload.data);
                }
                dispatch.platformCompanies.setLastError(null);
                await dispatch.platformCompanies.fetchCompanies();
            } catch (error: any) {
                dispatch.platformCompanies.setLastError(error?.message || 'Failed to save company');
                throw error;
            }
        }
    })
};
